<template>
    <div class="layout">
        <!-- header -->
        <header>
            <div class="div1">
                <div id="div2" class="div2" :class="{ 'div2_1': isFlagTrue }">
                    <div class="headerwrap" @mouseover="ouseoverC(true)" @mouseout="ouseoverC(false)">
                        <div class="header">
                            <a href="/" class="logo">
                                <img v-if="!isFlagTrue"
                                    src="@/assets/images/商城logo灰.png"
                                    class="logo0" />
                                <img v-else
                                    src="@/assets/images/商城logo.png"
                                    class="logo0" />
                            </a>
                            <nav>
                                <div style="height: 62px;">
                                    <transition name="el-zoom-in-bottom">
                                        <ul v-if="!isSearchOpen" class="nav">
                                            <li>
                                                <router-link to="/home">首页</router-link>
                                            </li>

                                            <li><a href="javascript:;" @click="toPath('/product/list', 100)">核心产品</a>
                                                <div class="nav02">
                                                    <a @click="toPath('/product/list', 1)" href="javascript:;"> 水质监测<i
                                                            class="fa fa-angle-right" aria-hidden="true"></i></a>
                                                    <!-- <a @click="toPath('/product/qtjc', 2)" href="javascript:;">气体检测<i
                                                            class="fa fa-angle-right" aria-hidden="true"></i></a> -->
                                                    <a @click="toPath('/product/sctt', 3)" href="javascript:;">数采和探头<i
                                                            class="fa fa-angle-right" aria-hidden="true"></i></a>
                                                    <a @click="toPath('/product/yjfn', 4)" href="javascript:;">解决方案<i
                                                            class="fa fa-angle-right" aria-hidden="true"></i></a>
                                                </div>
                                            </li>

                                            <li><a href="javascript:;" @click="toPath('/case/list', 1)">成功案例</a>
                                                <div class="nav02">
                                                    <a @click="toPath('/case/list', 1)" href="javascript:;">水环境质量智慧监测<i
                                                            class="fa fa-angle-right" aria-hidden="true"></i></a>
                                                    <!-- <a @click="toPath('/case/list', 2)" href="javascript:;">气体环境监测监管<i
                                                            class="fa fa-angle-right" aria-hidden="true"></i></a> -->
                                                </div>
                                            </li>
                                            <li>
                                                <router-link to="/news">新闻中心</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/about">关于我们</router-link>
                                            </li>
                                            <li><router-link to="/contact/list">联系我们</router-link>
                                                <div class="nav02">
                                                    <div class="nav04">
                                                        <router-link to="/contact/list">联系我们 <i class="fa fa-angle-right"
                                                                aria-hidden="true"></i></router-link>
                                                    </div>
                                                    <router-link to="/contact/dlsmh">代理商门户 <i class="fa fa-angle-right"
                                                            aria-hidden="true"></i></router-link>
                                                    <router-link to="/contact/zpmh"> 招聘门户 <i class="fa fa-angle-right"
                                                            aria-hidden="true"></i></router-link>
                                                </div>
                                            </li>
                                        </ul>
                                    </transition>
                                    <transition name="el-zoom-in-top">
                                        <div class="header_searchNew" v-if="isSearchOpen">
                                            <i class="el-icon-search"></i>
                                            <el-autocomplete class="inline-input" clearable v-model="searchVal"
                                                :fetch-suggestions="querySearch" placeholder="请输入产品名称"
                                                @select="handleSelect"></el-autocomplete>
                                            <i class="el-icon-close" @click="isSearchOpen = false"></i>
                                        </div>
                                    </transition>
                                </div>
                            </nav>
                            <div class="right" style="width:160px;display: flex;justify-content: center;align-items: center;" @click="isSearchOpen = true">
                                <img v-if="!isFlagTrue"
                                    src="http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/home/搜索b.png" alt="">
                                <img v-else src="http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/home/搜索.png"
                                    alt="">
                            </div>

                            <!-- 手机 -->
                            <button type="button" @click="toggleNav" style="display: none;"
                                class="drawer-toggle-b drawer-toggle drawer-hamburger"> <span
                                    class="drawer-hamburger-icon"></span>
                                <i v-if="!navExpend" class="el-icon-s-unfold"></i>
                                <i v-if="navExpend" class="el-icon-close"></i>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </header>
        <router-view></router-view>
        <footer class="footer">
            <div class="footerwrap">
                <div class="footer02">
                    <ul class="top">
                        <li>
                            <div class="item">
                                <h3><a href="javascript:;">核心产品</a></h3>
                                <div class="min">
                                    <p> <a @click="toPath('/product/list', 1)" href="javascript:;">水质监测</a></p>
                                    <!-- <p> <a @click="toPath('/product/qtjc', 2)" href="javascript:;">气体监测</a></p> -->
                                    <p> <a @click="toPath('/product/sctt', 3)" href="javascript:;">数采和探头</a></p>
                                    <p> <a @click="toPath('/product/yjfn', 4)" href="javascript:;">解决方案</a></p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <h3><a href="javascript:;">成功案例</a></h3>
                                <div class="min">
                                    <p> <a @click="toPath('/case/list', 1)" href="javascript:;">水环境质量智慧监测</a></p>
                                    <!-- <p> <a @click="toPath('/case/list', 2)" href="javascript:;">气体环境监测监管</a></p> -->
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <h3><a href="javascript:;">新闻中心</a></h3>
                                <div class="min">
                                    <p> <router-link to="/news">新闻中心</router-link></p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <h3><a href="javascript:;">关于我们</a></h3>
                                <div class="min">
                                    <p> <router-link to="/about">公司简介</router-link></p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <h3><a href="javascript:;">联系我们</a></h3>
                                <div class="min">
                                    <p> <router-link to="/contact/list">联系我们</router-link></p>
                                    <p> <router-link to="/contact/dlsmh">代理商门户</router-link></p>

                                    <p> <router-link to="/contact/zpmh">招聘门户</router-link></p>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <div class="bot">
                        <div class="left">
                            <a href="javascript:;" class="f-logo">
                                <img src="@/assets/images/商城logo灰.png"
                                    style="height: 30px" /></a>
                            <div class="f-nav">
                                <!-- <a href="/about/">关于我们</a>
                                <a href="/contact/">联系我们</a>
                                <a href="/agent/">代理商门户</a>
                                <a href="/bltjob/join/">招聘门户</a> -->
                                <p> <router-link to="/about">关于我们</router-link></p>
                                &nbsp; &nbsp; &nbsp; &nbsp;
                                <p> <router-link to="/contact/list">联系我们</router-link></p>
                                &nbsp; &nbsp; &nbsp; &nbsp;
                                <p> <router-link to="/contact/dlsmh">代理商门户</router-link></p>
                                &nbsp; &nbsp; &nbsp; &nbsp;
                                <p> <router-link to="/contact/zpmh">招聘门户</router-link></p>
                                &nbsp; &nbsp; &nbsp; &nbsp;
                            </div>
                        </div>
                        <ul class="right">
                            <li>
                                <a href="javascript:;"><img
                                        src="http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/home/wx.png" /></a>
                                <div class="popup">
                                    <div class="er-code">
                                        <img src="http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/home/销售微信.jpg" />
                                    </div>
                                    <div class="triangle"></div>
                                </div>
                            </li>

                            <li>
                                <a href="javascript:;"><img
                                        src="http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/home/xcx.png" /></a>
                                <div class="popup">
                                    <div class="er-code">
                                        <img
                                            src="http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/home/微信公众号.jpg" />
                                    </div>
                                    <div class="triangle"></div>
                                </div>
                            </li>
                            <!-- <li>
                                <a href="javascript:;"><img src="../../assets/images/newimages/txsp.png" /></a>
                                <div class="popup" >
                                    <div class="er-code">
                                        <img src="../../assets/images/code.png" />
                                    </div>
                                    <div class="triangle"></div>
                                </div>
                            </li>
                            <li>
                                <a href="javascript:;"><img src="../../assets/images/newimages/dy.png" /></a>
                                <div class="popup" >
                                    <div class="er-code">
                                        <img src="../../assets/images/code.png" />
                                    </div>
                                    <div class="triangle"></div>
                                </div>
                            </li> -->
                        </ul>
                    </div>

                    <div class="copyright02">
                        <div class="right">
                            <div class="item">
                                <p>© 2024 新锐鹏 All rights reserved</p>
                                <div class="link">
                                    <p> <router-link to="/others/Privacypolicy">隐私权政策</router-link></p>
                                    <i></i>
                                    <p> <router-link to="/others/Terms">使用条款</router-link></p>
                                    <i></i>
                                    <p> <router-link to="/others/gis">网站地图</router-link></p>
                                    <i></i>
                                    <p>新锐鹏科技有限公司</p>
                                    <i></i>

                                    <!-- <a href="/secret01/">隐私权政策</a>
                                    <i></i>
                                    <a href="/secret02/">使用条款</a>
                                    <i></i>
                                    <a href="/navigation/">网站地图</a>
                                    <i></i>
                                    <a href="###">湖北新锐鹏科技有限公司</a>
                                    <i></i> -->
                                    <a href="https://beian.miit.gov.cn/" target="blank" class="ba">鄂ICP备2023025333号</a>
                                </div>
                            </div>
                            <div class="item">
                                <a href=""></a>

                                <font>本网站直接或间接向消费者推销商品或者服务的商业宣传均属于“广告”（包装及参数、售后保障等商品信息除外）</font>
                                <a href="http://www.songyi.net" target="blank" class="ba" style="
                      font-family: Arial;
                      letter-spacing: 0;
                      font-size: 0;
                      opacity: 0;
                    ">Powered by SE</a>
                            </div>
                        </div>
                        <!-- <a href="/en/" class="f-language">
                            <img src="../../assets/images/newimages/地球.png" alt="" />EN</a> -->
                    </div>
                </div>
            </div>

            <!-- <div class="footer-down">
                {{ companyInfo.name }} 版权所有 2012-2018 苏ICP备16030849号
            </div> -->
        </footer>
        <el-dialog title="申请合作" :visible.sync="dialogFormVisible" :width="dialogWidth">
            <el-form :model="form" :hide-required-asterisk="true" :rules="rules" ref="formRef">
                <div class="row df jcsb row1">
                    <div class="form-item">
                        <el-form-item label="" label-width="auto" prop="name">
                            <el-input placeholder="您的称呼：（必填）" v-model="form.name" autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <el-form-item label="" label-width="auto" prop="tel">
                            <el-input v-model="form.tel" placeholder="联系方式：（必填）" autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <el-form-item label="" label-width="auto" prop="mail">
                            <el-input v-model="form.mail" placeholder="电子邮件：（必填）" autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="row df jcsb row2">
                    <div class="form-item">
                        <el-form-item label="" label-width="auto">
                            <el-input v-model="form.company" placeholder="公司全称：" autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <el-form-item label="" label-width="auto">
                            <el-input v-model="form.trade" placeholder="所属行业：" autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <el-form-item label="" label-width="auto">
                        <el-input type="textarea" placeholder="您的需求：" v-model="form.requirement"
                            autocomplete="off"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <p>请填写您的信息，我们尽快与您取得联系</p>
                <div class="submit" @click="submit">提交信息</div>
            </div>
        </el-dialog>
        <transition name="el-zoom-in-top">
            <div class="expend-nav" id="expend-nav" v-if="navExpend">
                <!-- <ul class="nav">
                    <li><router-link to="/home">首页</router-link></li>
                    <li><router-link to="/product">核心产品</router-link></li>
                    <li><router-link to="/Success">成功案例</router-link></li>
                    <li><router-link to="/news">新闻中心</router-link></li>
                    <li><router-link to="/about">关于我们</router-link></li>
                    <li><router-link to="/contact">联系我们</router-link></li>
                </ul> -->
                <el-menu :default-active="activeIndex" class="el-menu-demo">
                    <el-menu-item index="1">
                        <span slot="title"> <span @click="toPath('/home', 2)">首页</span></span>
                    </el-menu-item>
                    <el-submenu index="2">
                        <template slot="title">核心产品</template>
                        <el-menu-item index="2-1"><span @click="toPath('/product/list', 1)">水质监测</span></el-menu-item>
                        <el-menu-item index="2-2"><span @click="toPath('/product/qtjc', 2)">气体检测</span></el-menu-item>
                        <el-menu-item index="2-3"><span @click="toPath('/product/sctt', 3)">解决方案</span></el-menu-item>
                        <el-menu-item index="2-3"><span @click="toPath('/product/yjfn', 4)">数采和探头</span></el-menu-item>
                    </el-submenu>
                    <el-submenu index="3">
                        <template slot="title"><span>成功案例</span></template>
                        <el-menu-item index="3-1"><span @click="toPath('/case/list', 1)">水环境质量智慧监测</span></el-menu-item>
                        <!-- <el-menu-item index="3-2"><span @click="toPath('/case/list', 2)">气体环境监测监管</span></el-menu-item> -->

                    </el-submenu>
                    <el-menu-item index="4">
                        <span slot="title"><span @click="toPath('/news', 2)">新闻中心</span> </span>
                    </el-menu-item>

                    <el-submenu index="5">
                        <template slot="title">联系我们</template>
                        <el-menu-item index="5-1"><span @click="toPath('/contact/list')">联系我们</span></el-menu-item>
                        <el-menu-item index="5-2"><span @click="toPath('/contact/dlsmh')">代理商门户</span></el-menu-item>
                        <el-menu-item index="5-3"><span @click="toPath('/contact/zpmh')">招聘门户</span></el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </transition>
        <transition name="el-fade-in-linear">
            <div class="fixed-btns df fdc" v-show="this.top > 100 && !navExpend">
                <div class="return-btn df jcc aic" @click="backHome">
                    <i class="iconfont icon-shouye"></i>
                </div>
                <div class="return-btn df jcc aic" @click="backTop">
                    <i class="iconfont icon-shuangjiantou-shang"></i>
                </div>
            </div>
        </transition>

    </div>
</template>
<script>
import $ from 'jquery';
import { productData } from "@/assets/js/data.js";
import { companyInfo } from "@/assets/js/data.js";
import { newsData } from "@/assets/js/data.js";
import { mapState } from "vuex";
const { productList, typeArr } = productData;
const { newsList, typeArr: newsTypeArr } = newsData;
export default {
    data() {
        return {
            activeIndex: '',
            isFlagTrue: false,
            activeSubmenu: "",
            isSearchOpen: false,
            searchVal: "",
            productList,
            typeArr,
            newsList,
            newsTypeArr,
            hasCooperation: false,
            dialogFormVisible: false, // 合作弹框
            dialogWidth: "50%", // 合作弹框宽度
            form: {
                name: "",
                tel: "",
                mail: "",
                company: "",
                trade: "",
                requirement: "",
            },
            rules: {
                name: [
                    {
                        type: "string",
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur",
                    },
                ],
                tel: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
                mail: [
                    { required: true, message: "请输入电子邮箱", trigger: "blur" },
                    {
                        type: "email",
                        message: "请输入正确的邮箱地址",
                        trigger: ["blur", "change"],
                    },
                ],
            },
            navItems: [
                {
                    title: "首页",
                    path: "/home",
                },
                {
                    title: "核心产品",
                    path: "/product",
                    submenu: [
                        { title: "水质监测", path: "/product", name: '水质监测', id: 0 },
                        // { title: "气体检测", path: "/product", name: '气体检测', id: 1 },
                        { title: "数采和探头", path: "/product", name: '数采和探头', id: 2 },
                        { title: "解决方案", path: "/product", name: '产品列表', id: 3 },
                    ],
                },
                {
                    title: "成功案例",
                    path: "/case",
                    submenu: [
                        { title: "水环境质量智慧监测", path: "/case", name: '成功案例', id: 0 },
                        // { title: "气体环境监测监管", path: "/case", name: '成功案例', id: 1 },

                    ],
                },
                {
                    title: "新闻中心",
                    path: "/news",
                },
                {
                    title: "关于我们",
                    path: "/about",
                },
                {
                    title: "联系我们",
                    path: "/contact",
                    submenu: [
                        { title: "联系我们", path: "/contact/list", name: '联系我们', id: 0 },
                        { title: "代理商门户", path: "/contact/dlsmh", name: '代理商门户', id: 1 },
                        { title: "招聘门户", path: "/contact/zpmh", name: '招聘门户', id: 2 },

                    ],
                },
                // ...更多一级菜单
            ],
            navExpend: false, // 导航展开
            // hideHeader: false, // 隐藏头部
            lastScrollTop: 0, // 上一次滚动的位置
            top: 0,
            language: "zn", //语种
            companyInfo,
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        ouseoverC(val) {
            if (this.$route.name == '首页') {
                return
            }
            this.isFlagTrue = val
        },
        isInViewPortOfOne(element, val) {
            // 获取可视窗口的高度。兼容所有浏览器
            const screenHeight = window.innerHeight || document.documentElement.clientHeight
                || document.body.clientHeight;
            // 获取滚动条滚动的高度
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            // 获取元素偏移的高度。就是距离可视窗口的偏移量。
            const offsetTop = element.getBoundingClientRect();
            if ((offsetTop.top + 20 - screenHeight) > 0) {
                return false
            } else {
                return true
            }

        },

        showSubmenu(item) {
            this.activeSubmenu = item.title;
        },
        hideSubmenu() {
            this.activeSubmenu = null;
        },
        querySearch(queryString, cb) {
            this.productList = this.productList.map((item) => {
                return {

                    ...item,
                    value: item.title,
                }
            })
            var productList = this.productList;
            var results = queryString
                ? productList.filter(this.createFilter(queryString))
                : productList;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (item) => {
                return item.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
            };
        },
        handleSelect(item) {
            if (this.$route.path != "/product/detail") {
                this.$router.push({
                    path: "/product/detail",
                    query: { id: item.id },
                });
            }
            this.$store.commit("CHANGE_PRODUCT_ID", item.id);
        },
        submit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    this.dialogFormVisible = false;
                    this.$message({
                        message: "提交成功",
                        type: "success",
                    });
                } else {
                    console.log("error submit!!");
                }
            });
        },
        hideMenu(event) {
            // 点击菜单或菜单子元素,隐藏菜单
            if (this.navExpend) {
                // 获取下拉菜单的DOM节点
                const menu = document.getElementById("expend-nav");
                // console.log(menu, 'menu');
                // 检查点击目标是否是下拉菜单或其子元素
                if (menu && menu.contains(event.target)) {
                    // 点击目标是下拉菜单或其子元素，隐藏菜单
                    this.navExpend = false;
                }
            }
        },
        toggleNav() {
            // 移动端导航显示与隐藏
            console.log(this.navExpend)
            this.navExpend = !this.navExpend;
        },
        handleScroll() {
            // 监听滚动
            this.top =
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                window.pageYOffset;
            // console.log(this.top, 'top');
        },
        backHome() {
            this.$router.push(
                {
                    path: "/home",
                },
                () => { }
            );
            this.hideHeader = false;
        },
        backTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
        toPath(url, query) {
            console.log(url)
            this.navExpend = false
            // this.$router.go(0);
            this.$router.push(
                {
                    path: url,
                    query: { type: query, data: new Date() },

                },

            );

        },
        setDialogWidth() {
            // const screenWidth = document.documentElement.clientWidth
            const screenWidth = window.innerWidth;
            // console.log(screenWidth, 'screenWidth');
            if (screenWidth <= 1024) {
                this.dialogWidth = "90%";
            } else {
                this.dialogWidth = "50%";
            }
        },
        languageAuto() {
            // 中英文切换
            this.language == "zh" ? (this.language = "en") : (this.language = "zh");
            localStorage.setItem("language", `{"language":"${this.language}"}`);
            if (this.language == "zh") {
                console.log("转为中文");
                this.$translate.changeLanguage("chinese_simplified");
            }
            if (this.language == "en") {
                console.log("转为英文");
                this.$translate.changeLanguage("english");
            }
            this.$translate.execute(); //进行翻译
        },
    },
    created() { },
    mounted() {
        const myDivL = document.getElementsByClassName('left-home-0');//动画1
        $(".left-home-0").addClass('hidden')
        if (this.$route.name == '首页' && this.isInViewPortOfOne(myDivL[0])) {

            if (this.isInViewPortOfOne(myDivL[0])) {
                $(".left-home-0").removeClass('hidden')
                $(".left-home-0").attr("aosL", 'fade-up');//从左侧滑入
                console.log('划入')
            }
        }
        //首页头部
        this.setDialogWidth();
        let that = this
        if (that.$route.name == '首页') {
            that.isFlagTrue = true
            // div2.className = "div2_1";
            $(".div2").addClass("div2_1")
        }
        // document.addEventListener("click", this.hideMenu);
        // window.addEventListener("resize", this.setDialogWidth);
        // window.addEventListener("scroll", this.handleScroll);
        window.addEventListener('scroll', () => {

            var t = document.documentElement.scrollTop || document.body.scrollTop;
            var div2 = document.getElementById("div2");
            if (t >= 200 || that.$route.name == '成功案例详情' || that.$route.name == '首页') {
                that.isFlagTrue = true
                // div2.className = "div2_1";
                $(".div2").addClass("div2_1")
            } else {
                that.isFlagTrue = false
                // div2.className = "div2";
                $(".div2").removeClass("div2_1")
            }
            // 首页 特效
            if (that.$route.name == '首页') {
                $(".left-home-0").addClass('hidden')
                $(".left-home-1").addClass('hidden')
                $(".left-home-2").addClass('hidden')
                $(".left-home-3").addClass('hidden')
                $(".left-home-4").addClass('hidden')
                $(".right-home-5").addClass('hidden')
                $(".left-home-5").addClass('hidden')
                $(".left-home-6").addClass('hidden')
                $(".left-home-75").addClass('hidden')
                $(".left-home-8").addClass('hidden')
                $(".right-home-8").addClass('hidden')
                const myDiv0 = document.getElementsByClassName('left-home-0');//动画0
                const myDiv1 = document.getElementsByClassName('left-home-1');//动画1
                const myDiv2 = document.getElementsByClassName('left-home-2');//动画2
                const myDiv3 = document.getElementsByClassName('left-home-3');//动画2
                const myDiv4 = document.getElementsByClassName('left-home-4');//动画4
                const myDiv5 = document.getElementsByClassName('left-home-5');//动画4
                const myDiv6 = document.getElementsByClassName('left-home-6');//动画4
                const myDiv7 = document.getElementsByClassName('left-home-7');//动画4
                const myDiv8 = document.getElementsByClassName('left-home-8');//动画4
                if (that.isInViewPortOfOne(myDiv0[0])) {
                    $(".left-home-0").removeClass('hidden')
                    $(".left-home-0").attr("aosL", 'fade-up');//从下
                }
                if (that.isInViewPortOfOne(myDiv1[0])) {
                    $(".left-home-1").removeClass('hidden')
                    $(".left-home-1").attr("aosL", 'fade-up');//从下

                }
                if (that.isInViewPortOfOne(myDiv2[0])) {
                    $(".left-home-2").removeClass('hidden')
                    $(".left-home-2").attr("aosL", 'fade-up');//从下

                }
                if (that.isInViewPortOfOne(myDiv3[0])) {
                    $(".left-home-3").removeClass('hidden')
                    $(".left-home-3").attr("aosL", 'fade-up');//从下

                }
                if (that.isInViewPortOfOne(myDiv4[0])) {
                    $(".left-home-4").removeClass('hidden')
                    $(".left-home-4").attr("aosL", 'fade-left');//从

                }
                if (that.isInViewPortOfOne(myDiv5[0])) {
                    $(".left-home-5").removeClass('hidden')
                    $(".right-home-5").removeClass('hidden')
                    $(".left-home-5").attr("aosL", 'fade-left');//从
                    $(".right-home-5").attr("aosL", 'fade-right');//从

                }
                if (that.isInViewPortOfOne(myDiv6[0])) {
                    $(".left-home-6").removeClass('hidden')
                    $(".left-home-6").attr("aosL", 'fade-up');//从下

                }
                if (that.isInViewPortOfOne(myDiv7[0])) {
                    $(".left-home-75").removeClass('hidden')
                    $(".left-home-75").attr("aosL", 'fade-up');//从下

                }
                if (that.isInViewPortOfOne(myDiv8[0])) {
                    $(".left-home-8").removeClass('hidden')
                    $(".right-home-8").removeClass('hidden')
                    $(".left-home-8").attr("aosL", 'fade-left');//从下
                    $(".right-home-8").attr("aosL", 'fade-right');//从下

                }
                // if (t > 3200) {

                // }
            }
            if (that.$route.name == '成功案例') {
                $(".left-case-0").addClass('hidden')
                const myDiv0 = document.getElementsByClassName('left-case-0');//动画0
                if (that.isInViewPortOfOne(myDiv0[0])) {
                    $(".left-case-0").removeClass('hidden')
                    $(".left-case-0").attr("aosL", 'fade-up');//从下
                }
            }
            if (that.$route.name == '关于我们') {
                $(".left-about-0").addClass('hidden')
                $(".left-about-1").addClass('hidden')
                $(".right-about-1").addClass('hidden')
                $(".left-about-2").addClass('hidden')
                $(".left-about-3").addClass('hidden')
                const myDiv0 = document.getElementsByClassName('left-about-0');//动画
                const myDiv1 = document.getElementsByClassName('left-about-1');//动画
                const myDiv2 = document.getElementsByClassName('left-about-2');//动画
                const myDiv3 = document.getElementsByClassName('left-about-3');//动画
                if (that.isInViewPortOfOne(myDiv0[0])) {
                    $(".left-about-0").removeClass('hidden')
                    $(".left-about-0").attr("aosL", 'fade-up');//从下
                }
                if (that.isInViewPortOfOne(myDiv1[0])) {
                    $(".left-about-1").removeClass('hidden')
                    $(".right-about-1").removeClass('hidden')
                    $(".left-about-1").attr("aosL", 'fade-left');//从左
                    $(".right-about-1").attr("aosL", 'fade-right');//从右

                }
                if (that.isInViewPortOfOne(myDiv2[0])) {
                    $(".left-about-2").removeClass('hidden')
                    $(".left-about-2").attr("aosL", 'fade-up');//从下
                }
                if (that.isInViewPortOfOne(myDiv3[0])) {
                    $(".left-about-3").removeClass('hidden')
                    $(".left-about-3").attr("aosL", 'fade-up');//从下
                }


                // }
            }
            if (that.$route.name == '代理商门户') {
                $(".left-contact-0").addClass('hidden')
                $(".left-contact-1").addClass('hidden')
                $(".right-contact-1").addClass('hidden')
                $(".left-contact-2").addClass('hidden')
                $(".left-contact-3").addClass('hidden')
                $(".left-contact-4").addClass('hidden')
                const myDiv0 = document.getElementsByClassName('left-contact-0');//动画0
                const myDiv1 = document.getElementsByClassName('left-contact-1');//动画0
                const myDiv2 = document.getElementsByClassName('left-contact-2');//动画0
                const myDiv3 = document.getElementsByClassName('left-contact-3');//动画0
                const myDiv4 = document.getElementsByClassName('left-contact-4');//动画0
                if (that.isInViewPortOfOne(myDiv0[0])) {
                    $(".left-contact-0").removeClass('hidden')
                    $(".left-contact-0").attr("aosL", 'fade-up');//从下
                }
                if (that.isInViewPortOfOne(myDiv1[0])) {
                    $(".left-contact-1").removeClass('hidden')
                    $(".right-contact-1").removeClass('hidden')
                    $(".left-contact-1").attr("aosL", 'fade-left');//从左
                    $(".right-contact-1").attr("aosL", 'fade-right');//从右

                }
                if (that.isInViewPortOfOne(myDiv2[0])) {
                    $(".left-contact-2").removeClass('hidden')
                    $(".left-contact-2").attr("aosL", 'fade-up');//从下
                }
                if (that.isInViewPortOfOne(myDiv3[0])) {
                    $(".left-contact-3").removeClass('hidden')
                    $(".left-contact-3").attr("aosL", 'fade-up');//从下
                }
                if (that.isInViewPortOfOne(myDiv4[0])) {
                    $(".left-contact-4").removeClass('hidden')
                    $(".left-contact-4").attr("aosL", 'fade-up');//从下
                }
            }
            if (that.$route.name == '招聘门户') {
                $(".left-zpmh-0").addClass('hidden')
                $(".left-zpmh-1").addClass('hidden')
                const myDiv0 = document.getElementsByClassName('left-zpmh-0');//动画0
                const myDiv1 = document.getElementsByClassName('left-zpmh-1');//动画0
                if (that.isInViewPortOfOne(myDiv0[0])) {
                    $(".left-zpmh-0").removeClass('hidden')
                    $(".left-zpmh-0").attr("aosL", 'fade-up');//从下
                }
                if (that.isInViewPortOfOne(myDiv1[0])) {
                    $(".left-zpmh-1").removeClass('hidden')
                    $(".left-zpmh-1").attr("aosL", 'fade-up');//从下
                }
            }
        }, true);
        if (that.$route.name == '成功案例详情') {
            $(".div2").addClass("div2_1")
        }


    },
    beforeDestroy() {
        document.removeEventListener("click", this.hideMenu);
        // document.removeEventListener("scroll", this.handleScroll);
    },
};
</script>
<style lang="scss" scoped>
.layout {
    .hide-header {
        transform: translateY(-100%);
        transition: all 0.3s;
    }

    .show-header {
        transform: translateY(0);
        transition: all 0.3s;
    }

    .header {
        .menu-btn {
            display: none;
        }

        .logo-box {
            width: 1.92rem;
            height: 1rem;
            // margin-right: 4.46rem;

            .logo-img {
                width: 100%;
                height: 100%;
            }
        }

        .header-middle {
            position: absolute;
            width: max-content;
            left: 25%;
        }

        .tel {
            font-weight: 500;
            font-size: 0.36rem;
            color: #011405;
            margin-right: 1.89rem;
        }

        .search {
            font-size: 0.28rem;
            cursor: pointer;
            margin-right: 0.33rem;
        }

        .language {
            font-size: 0.21rem;
            color: #011405;

            span {
                margin-right: 0.1rem;
            }
        }

        .header-search {
            position: absolute;
            // top: 50%;
            left: 26%;
            // transform: translateX(-50%);
            // transition: all 2s cubic-bezier(0.215, 0.61, 0.355, 1);
            width: 11rem;
            font-size: 0.28rem;

            .el-icon-close {
                cursor: pointer;

                &:hover {
                    opacity: 0.8;
                }
            }

            ::v-deep .el-autocomplete {
                width: 100%;

                .el-input__inner {
                    border: none;
                    font-size: 0.28rem;
                }
            }
        }
    }

    .cooperation {
        display: flex;

        .cooperation-left {
            height: 3.3rem;
            width: 50%;
            padding: 0.48rem 3.57rem 0.48rem 3.15rem;
            background: #00a0e8;

            .left-title {
                font-weight: 600;
                font-size: 0.48rem;
                color: #ffffff;
                margin-bottom: 0.39rem;
            }

            .left-btn {
                width: 2.04rem;
                height: 0.6rem;
                line-height: 0.6rem;
                background: rgba(255, 255, 255, 0.1);
                border: 0.01rem solid rgba(255, 255, 255, 0.5);
                gap: 0.18rem;
                font-size: 0.28rem;
                color: #ffffff;
                cursor: pointer;

                &:hover {
                    opacity: 0.8;
                }

                .icon-youjiantou {
                    font-size: 0.2rem;
                    color: #ffffff;
                }
            }
        }

        .cooperation-right {
            height: 3.3rem;

            img {
                height: 100%;
            }
        }
    }

    .footer {
        background: url("http://www.xrphuanbao.com:7599/images/xinruipeng/footer.png") no-repeat;
        background-size: 100% 100%;
        // padding-top: 1.2rem;

        .footerwrap {
            width: 100%;
            box-sizing: border-box;
            border-top: 4px solid #0081cc;
            background-color: #303132;
            padding: 90px 0;

            .footer02 .top li .item .min p,
            .footer02 .top li .item .min .xcxhover {
                margin-bottom: 20px;
                position: relative;
            }

            .footer02 .top li .item .min p:hover {
                color: #fff;
            }

            .footer02 .top li .item {
                margin-bottom: 40px;
            }

            .footer02 .top li .item .min:hover {
                color: #fff;
            }

            .footer02 .top li .item h3 {
                margin-bottom: 20px;
            }

            .footer02 .top li .item h3 a {
                font-size: 13px;
                color: #ffffff;
            }

            .footer02 .copyright02 {
                width: 100%;
                display: flex;
                display: -webkit-flex;
                -webkit-justify-content: space-between;
                justify-content: space-between;
                -webkit-align-items: flex-start;
                align-items: flex-start;
            }

            .footer02 .bot .left {
                display: flex;
                display: -webkit-flex;
                -webkit-justify-content: flex-start;
                justify-content: flex-start;
                -webkit-align-items: center;
                align-items: center;
            }

            .footer02 .bot .left .f-nav {
                display: flex;
                display: -webkit-flex;
                -webkit-justify-content: flex-start;
                justify-content: flex-start;
                -webkit-align-items: center;
                align-items: center;
                margin-left: 40px;
            }

            .footer02 .bot .left .f-logo img {
                display: block;
                width: auto;
                height: 30px;
                opacity: 0.8;
            }

            .footer02 .bot .left .f-nav a:hover {
                color: #ffffff;
            }

            .footer02 .bot .right {
                display: flex;
                display: -webkit-flex;
                -webkit-justify-content: flex-start;
                justify-content: flex-start;
                align-items: center;
                -webkit-align-items: center;
            }

            .footer02 .bot .right li a {
                display: block;
                width: 18px;
            }

            .footer02 .bot .left .f-nav a {
                font-size: 12px;
                color: #9fa3a6;
                position: relative;
                margin-right: 20px;
                display: block;
            }

            .footer02 .copyright02 .f-language img {
                margin-right: 10px;
            }

            @media only screen and (max-width: 1600px) {
                .footer02 .bot .right li {
                    margin-right: 15px;
                }
            }

            .footer02 .bot .right li {
                position: relative;
                margin-right: 20px;
            }

            .footer02 .copyright02 .right .item:last-child {
                margin-bottom: 0;
            }

            .footer02 .copyright02 .right .item p {
                font-size: 12px;
                color: #9fa3a6;
            }

            .footer02 .copyright02 .right .item .link i {
                display: block;
                width: 3px;
                height: 3px;
                background-color: #9fa3a6;
                border-radius: 50%;
                margin: 0 5px;
            }

            .footer02 .copyright02 .right .item font {
                margin-left: 20px;
            }

            .footer02 .copyright02 .right .item .ba,
            .footer02 .copyright02 .right .item font {
                font-size: 12px;
                color: #9fa3a6;
            }

            .footer02 .copyright02 .right .item .link {
                display: flex;
                display: -webkit-flex;
                -webkit-justify-content: flex-start;
                justify-content: flex-start;
                -webkit-align-items: center;
                align-items: center;
                margin-left: 30px;
            }

            .footer02 .copyright02 .right .item .link:hover {
                color: #fff;
            }

            .footer02 .copyright02 .right .item .link a {
                font-size: 12px;
                color: #9fa3a6;
                position: relative;
                display: block;
            }

            .footer02 .copyright02 .right .item {
                display: flex;
                display: -webkit-flex;
                -webkit-justify-content: flex-start;
                justify-content: flex-start;
                -webkit-align-items: center;
                align-items: center;
                margin-bottom: 10px;
            }

            .footer02 .copyright02 .right .item {
                display: flex;
                display: -webkit-flex;
                -webkit-justify-content: flex-start;
                justify-content: flex-start;
                -webkit-align-items: center;
                align-items: center;
                margin-bottom: 10px;
            }

            .footer02 .copyright02 {
                width: 100%;
                display: flex;
                display: -webkit-flex;
                -webkit-justify-content: space-between;
                justify-content: space-between;
                -webkit-align-items: flex-start;
                align-items: flex-start;
            }

            .footer02 {
                width: 1200px;
                margin: auto;
                box-sizing: border-box;

                .top {
                    width: 100%;
                    display: flex;
                    display: -webkit-flex;
                    justify-content: space-between;
                    -webkit-align-items: flex-start;
                    align-items: flex-start;
                    margin-bottom: 50px;

                    ::marker {
                        unicode-bidi: isolate;
                        font-variant-numeric: tabular-nums;
                        text-transform: none;
                        text-indent: 0px !important;
                        text-align: start !important;
                        text-align-last: start !important;
                    }
                }

                .min:hover {
                    color: #fff;
                }

                .bot {
                    width: 100%;
                    box-sizing: border-box;
                    display: flex;
                    display: -webkit-flex;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    -webkit-align-items: center;
                    align-items: center;
                    padding-bottom: 15px;
                    border-bottom: 1px solid #6c7073;
                    margin-bottom: 20px;

                    .right {

                        .footer02 .bot .right li .popup,
                        .footer02 .top li .item .min .xcxhover .popup {
                            display: block;
                            position: absolute;
                            bottom: 20px;
                            right: -10px;
                            width: 144px;
                            height: 160px;
                            transition: all 0.3s;
                            opacity: 0;
                            display: none;
                        }
                    }
                }
            }
        }
    }

    // 申请合作弹框
    ::v-deep .el-dialog__header {
        text-align: center;
        padding: 0.3rem 0;
        padding-bottom: 0;

        .el-dialog__title {
            display: inline-block;
            font-weight: 500;
            font-size: 0.48rem;
            color: #011405;
            padding-top: 0.27rem;
        }

        .el-dialog__headerbtn .el-dialog__close {
            color: #011405;
        }
    }

    ::v-deep .el-dialog__body {
        padding: 0.3rem 0.69rem 0.69rem;
    }

    .form-item {
        border: 0.02rem solid #011405;
        border-radius: 2px;
    }

    .row {
        gap: 0.39rem;
        margin-bottom: 0.3rem;
    }

    .row1 {
        .form-item {
            width: 33%;
        }
    }

    .row2 {
        .form-item {
            width: 50%;
        }
    }

    ::v-deep .el-form-item {
        margin: 0;
        padding: 0.13rem 0.18rem;

        .el-form-item__content {
            line-height: 1;

            .el-input__inner {
                border: none;
                height: auto;
                line-height: 1;
                padding: 0;
                font-size: 0.24rem;

                &::placeholder {
                    color: #011405;
                }
            }

            .el-form-item__error {
                font-size: 0.18rem;
                padding-top: 1em;
            }

            .el-textarea__inner {
                border: none;
                padding: 0;
                font-size: 0.24rem;

                &::placeholder {
                    color: #011405;
                }
            }
        }
    }

    ::v-deep .el-dialog__footer {
        padding: 0;
    }

    .dialog-footer {
        text-align: center;
        padding-bottom: 1.2rem;

        p {
            font-weight: 400;
            font-size: 0.18rem;
            color: #011405;
            line-height: 0.25rem;
            margin-bottom: 0.12rem;
        }

        .submit {
            width: 1.32rem;
            height: 0.54rem;
            line-height: 0.54rem;
            background: #011405;
            text-align: center;
            font-size: 0.24rem;
            color: #ffffff;
            margin: 0 auto;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }
        }
    }

    .fixed-btns {
        position: fixed;
        bottom: 15%;
        right: 1%;
        gap: 0.09rem;
        z-index: 1000;

        .return-btn {
            width: 0.8rem;
            height: 0.8rem;
            background: #e7e7e7;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }

            .iconfont {
                color: #011405;
                font-size: 0.38rem;
            }

            .icon-shouye {
                font-size: 0.33rem;
            }
        }
    }
}

@media screen and (min-width: 368px) and (max-width: 1024px) {
    .layout {
        position: relative;

        .expend-nav {
            width: 100vw;
            height: 100%;
            position: fixed;
            top: 2.4rem;
            left: 0;
            bottom: 0;
            background-color: #fff;
            z-index: 200;

            ul {
                position: relative;
                height: 100vh;
                // overflow-y: auto;
                padding: 0.9rem 0.75rem;
                z-index: 300;

                li {
                    a {
                        font-weight: 400;
                        font-size: 0.42rem;
                        color: #011405;
                    }

                    margin-bottom: 0.9rem;
                }
            }
        }

        .header {
            height: 2.4rem;
            justify-content: space-between;
            padding: 0.6rem 0.75rem;

            .logo-box {
                width: 2.34rem;
                height: 1.26rem;
                // margin-right: 4.46rem;

                .logo-img {
                    width: 100%;
                    height: 100%;
                }
            }

            .header-middle {
                left: inherit;
                right: 2.32rem;

                .nav,
                .tel {
                    display: none;
                }

                .el-icon-search {
                    font-size: 0.8rem;
                }

                .language {
                    display: none;
                }
            }

            .header-search {
                width: 5.5rem;
                font-size: 0.8rem;

                ::v-deep .el-autocomplete {
                    .el-input {
                        display: flex;
                        align-items: center;
                    }

                    .el-input__inner {
                        border: none;
                        font-size: 0.5rem;
                        height: 100%;
                        line-height: 1;
                    }
                }
            }

            .menu-btn {
                display: inline-block;

                .iconfont {
                    font-size: 0.8rem;
                }
            }
        }

        .cooperation {
            flex-wrap: wrap;
            // height: max-content;

            .cooperation-left {
                width: 100%;
                padding: 0.48rem 0 0.48rem 1.05rem;
                background: #00a0e8;
                // height: 3.3rem;

                .left-title {
                    width: 5.28rem;
                    font-weight: 600;
                    font-size: 0.48rem;
                    color: #ffffff;
                    margin-bottom: 0.39rem;
                }

                .left-btn {
                    width: 2.04rem;
                    height: 0.6rem;
                    line-height: 0.6rem;
                    background: rgba(255, 255, 255, 0.1);
                    border: 0.01rem solid rgba(255, 255, 255, 0.5);
                    gap: 0.18rem;
                    font-size: 0.24rem;
                    color: #ffffff;
                    cursor: pointer;

                    &:hover {
                        opacity: 0.8;
                    }

                    .icon-youjiantou {
                        font-size: 0.2rem;
                        color: #ffffff;
                    }
                }
            }

            .cooperation-right {
                width: 100%;

                // height: 3.3rem;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .footer {
            // background: url('http://www.xrphuanbao.com:7599/images/xinruipeng/footer.png') no-repeat;
            // background-size: cover;

            .footer-top {
                // height: 6.64rem;
                // border-bottom: .01rem solid rgba(255, 255, 255, 0.1);
                padding: 0;
                padding-top: 0.75rem;
                padding-left: 1.05rem;
                // color: #CFD4DB;

                .footer-top--left {
                    .footer-logo {
                        width: 1.92rem;
                        height: 0.99rem;
                        margin-bottom: 0.3rem;
                    }

                    .footer-codes {
                        gap: 0.54rem;

                        .code {
                            gap: 0.15rem;
                            margin-bottom: 0.75rem;

                            .code-img {
                                width: 1.92rem;
                                height: 1.92rem;
                            }

                            .code-name {
                                font-size: 0.3rem;
                            }
                        }
                    }

                    .footer-contact {
                        font-size: 0.3rem;
                        gap: 0.18rem;
                    }
                }

                .footer-top--right {
                    display: none;
                }
            }

            .footer-down {
                // height: 1.05rem;
                // line-height: 1.05rem;
                // text-align: center;
                font-size: 0.27rem;
                // color: #6D6D6D;
            }
        }

        .fixed-btns {
            position: fixed;
            bottom: 10%;
            right: 1%;
            gap: 0.09rem;
            z-index: 1000;

            .return-btn {
                width: 1.2rem;
                height: 1.2rem;

                .iconfont {
                    font-size: 0.48rem;
                }

                .icon-shouye {
                    font-size: 0.44rem;
                }
            }
        }
    }
}

@media screen and (max-width: 820px) {
    .layout {

        // 申请合作弹框
        ::v-deep .el-dialog__header {
            padding: 0.75rem 0;
            padding-bottom: 0;

            .el-dialog__title {
                font-size: 0.54rem;
                padding-top: 0;
            }

            .el-dialog__headerbtn .el-dialog__close {
                color: #011405;
                font-weight: 500;
                font-size: 0.42rem;
            }
        }

        ::v-deep .el-dialog__body {
            padding: 0.45rem 0.75rem 0.75rem;
        }

        ::v-deep .el-form-item {
            margin: 0;
            padding: 0.42rem 0.3rem;

            .el-form-item__content {
                .el-input__inner {
                    font-size: 0.36rem;
                }

                .el-form-item__error {
                    font-size: 0.22rem;
                    padding-top: 0.8em;
                }

                .el-textarea__inner {
                    font-size: 0.36rem;
                }
            }
        }

        .row {
            flex-direction: column;
            gap: 0.45rem;
            margin-bottom: 0.45rem;
        }

        .row1,
        .row2 {
            .form-item {
                width: 100%;
            }
        }

        .dialog-footer {
            padding-bottom: 0.9rem;

            p {
                font-size: 0.36rem;
                line-height: 0.49rem;
                margin-bottom: 0.3rem;
            }

            .submit {
                width: 2.85rem;
                height: 0.84rem;
                line-height: 0.84rem;
                font-size: 0.3rem;
                color: #ffffff;
            }
        }
    }
}

.right li:hover .popup {
    display: block !important;
}